import React from 'react';
import Modal from 'app/common/modal';
import cookies, { cookieDomain, cookiePath } from 'app/utils/cookies';
import { connect } from 'react-redux';

import {
  createBoligAgent as signup,
  CREATE_SUCCESS
} from 'app/redux/modules/boligagents';
// import { create as signup } from 'app/redux/modules/auth';

import { goal } from 'kodyl-js/tracking';
// import tracking from 'app/utils/tracking';

import styles from './styles.scss';

let hasBeenShown = false;

class BoligAgentModal extends React.Component {
  constructor(props) {
    super(props);

    const cookieData = cookies.getItem('__bn_bam_cnt');
    const __cnt = cookieData === '-' ? 999 : Number(cookieData || 0) + 1;

    const show =
      !hasBeenShown && !props.existingUser && props.areaName && __cnt <= 3;

    this.state = {
      __cnt: __cnt,
      show: show,
      submitted: false,
      error: null
    };

    this._timer = null;
  }

  componentDidMount() {
    if (this.state.show) {
      hasBeenShown = true;
      this.setCookie(this.state.__cnt);
    }
  }

  componentWillUnmount() {
    if (this._timer) {
      clearTimeout(this._timer);
    }
  }

  setCookie(value) {
    cookies.setItem('__bn_bam_cnt', value, null, cookiePath, cookieDomain);
  }

  handleClose = () => {
    this.setState({ show: false });
  };

  handleChange = ev => {
    const { name, value } = ev.target;
    const val = value.trim();
    if (/\S+@\S+[.]\S+/.test(val)) {
      this.setState({ [name]: val });
    }
  };

  handleSubmit = ev => {
    ev.preventDefault();
    if (this.state.email) {
      this.props
        .signup(
          {
            email: this.state.email,
            prefs: [{ area: this.props.areaSlug }]
          },
          { noTracking: true }
        )
        .then(action => {
          if (action.type === CREATE_SUCCESS && action.status === 'OK') {
            try {
              goal({ name: 'Lead' });
              // tracking.action('boligagent-signup');
              // tracking.goal('boligagent-signup');
              // clicky.log('#boligagent/signup/modal', '');
              // tracking.event('boligagent', 'signup', 'modal');
              // window.clicky.goal('boligagent-signup');
              // window.clicky.log('#boligagent/signup/modal', '');
              window.ga('send', 'event', 'boligagent', 'signup', 'modal');
            } catch (err) {
              if (__DEV__) {
                console.error(err);
              }
            }

            this.setState({ submitted: true });
            this.setCookie('-');

            this._timer = setTimeout(() => {
              this.setState({ show: false });
            }, 5000);
          }

          console.log(action);
          if (action.status !== 'OK') {
            this.setState({ submitted: false, error: true });
          }

          return action;
        })
        .catch(err => {
          if (__DEV__) {
            console.error(err);
            // TODO: Log error!
          }
          console.log(err);
          this.setState({ submitted: false, error: true });
        });
    }
    return false;
  };

  render() {
    return (
      <Modal
        show={this.state.show}
        onClose={this.handleClose}
        keyboard
        className={styles.modal}
      >
        {() => {
          return (
            <div className="modal-body">
              <h2>
                Se boligerne i {this.props.areaName} før andre, helt gratis!
              </h2>
              {this.state.submitted ? (
                <p>
                  Du er nu tilmeldt vores <strong>gratis BoligAgent</strong> for{' '}
                  <strong>{this.props.areaName}</strong> - vi har sendt en email
                  til <strong>{this.state.email}</strong> med et link hvor du
                  skal bekræfte din tilmelding.
                </p>
              ) : (
                <>
                  <p>
                    BoligAgenten giver dig øjeblikkelig besked via email, når
                    der kommer nye attraktive boliger.
                  </p>
                  <form onSubmit={this.handleSubmit}>
                    <input
                      type="text"
                      name="email"
                      onChange={this.handleChange}
                      className={styles.textField}
                      placeholder="Indtast din e-mail"
                    />{' '}
                    <input
                      type="submit"
                      className={styles.submitField}
                      value="Tilmeld"
                    />
                  </form>
                  {this.state.error && (
                    <span style={{ color: 'red' }}>
                      Øv! Noget gik galt - prøv igen eller kontakt kundeservice
                    </span>
                  )}
                </>
              )}
              <span className={styles.terms}>
                <br />
                Du kan altid afmelde dig vores nyhedsbrev.{' '}
                <a href="/info/terms" target="_blank">
                  Se betingelser her.
                </a>
              </span>
            </div>
          );
        }}
      </Modal>
    );
  }
}

export default connect(
  ({ auth: { user, token }, boligagents: { sessionPrefs } }) => ({
    user,
    existingUser: token ? true : false,
    sessionPrefs
  }),
  { signup }
)(BoligAgentModal);
